import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { supabase } from '../utils/supabase';
import { Brain, MessageSquare } from 'lucide-react';

function Dashboard() {
  const navigate = useNavigate();
  const [user, setUser] = useState(null);

  useEffect(() => {
    supabase.auth.getSession().then(({ data: { session } }) => {
      if (!session) {
        navigate('/?signin=true');
        return;
      }
      setUser(session.user);
    });
  }, [navigate]);

  return (
    <div className="min-h-screen bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <h1 className="text-3xl font-bold text-gray-900 mb-8">Welcome to Your Dashboard</h1>
        
        <div className="grid md:grid-cols-2 gap-8">
          {/* Learning Hub Section */}
          <div className="bg-white rounded-xl p-6 shadow-lg">
            <div className="flex items-center mb-4">
              <Brain className="h-8 w-8 text-indigo-600" />
              <h2 className="text-xl font-semibold ml-3">Learning Hub</h2>
            </div>
            <p className="text-gray-600 mb-4">
              Access your AI learning materials and track your progress.
            </p>
            <button
              onClick={() => navigate('/learning-hub')}
              className="w-full bg-indigo-600 text-white px-4 py-2 rounded-lg hover:bg-indigo-700 transition-colors"
            >
              Go to Learning Hub
            </button>
          </div>

          {/* Tutor Hub Section */}
          <div className="bg-white rounded-xl p-6 shadow-lg">
            <div className="flex items-center mb-4">
              <MessageSquare className="h-8 w-8 text-purple-600" />
              <h2 className="text-xl font-semibold ml-3">Tutor Hub</h2>
            </div>
            <p className="text-gray-600 mb-4">
              Start a tutoring session or review past sessions.
            </p>
            <button
              onClick={() => navigate('/tutor-hub')}
              className="w-full bg-purple-600 text-white px-4 py-2 rounded-lg hover:bg-purple-700 transition-colors"
            >
              Go to Tutor Hub
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Dashboard;